export const paletteDefault = {
  // --------- basic colors -----------
  basicColors: [
    '#000000',
    '#f7faff',
    '#E1EAFE',
    '#E1EAFE',
    '#CCDBFD',
    '#2C60D3',
    '#0000EE',
    '#326EF4',
    '#FFFFFF',
    '#EBF2FF',
    '#D6E3FE',
    '#3471F9',
    '#3471F9',
    '#282B33',
    '#121826',
  ],

  // ---------- semantic colors ----------
  semanticColors: {
    red: '#FF4D4F',
    green: '#29A294',
  },
};
